export default "__VITE_ASSET__B3mfqeN7__"